import { useRef, useState } from 'react';
import { Button, Flex } from '@vibe/core';
import { PortalSettingsSchema } from '@gorilla/portal-shared/src/schemas';

type UploadPortalSettingsButtonProps = {
  onUploaded: (newPortalSettings: any) => void;
};

export function UploadPortalSettingsButton({ onUploaded }: UploadPortalSettingsButtonProps) {
  const [file, setFile] = useState<File | undefined>(undefined);
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <Flex gap={0} align="center">
      <div className="filepicker filepicker--upload filepicker--invalidsettings" style={{ flex: 1 }}>
        <input
          className="input_container"
          type="file"
          ref={fileInputRef}
          accept=".json,application/json"
          onChange={() => {
            if (fileInputRef.current?.files?.length) {
              setFile(fileInputRef.current.files[0]);
            } else {
              setFile(undefined);
            }
          }}
        />
        {/* 
        {file && <div className="filepicker__filename">{file.name}</div>}
        */}
      </div>
      <Button
        kind="primary"
        color="primary"
        size="medium"
        disabled={!file}
        onClick={() => {
          if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
              try {
                const newPortalSettings = JSON.parse(e.target?.result as string);

                if (!newPortalSettings) {
                  throw new Error('Invalid file format');
                }

                if (PortalSettingsSchema.safeParse(newPortalSettings).success) {
                  onUploaded(newPortalSettings);
                } else {
                  throw new Error('Invalid file format');
                }
              } catch (err) {
                alert('Invalid file format');
              }
            };
            reader.readAsText(file);
          }
        }}
      >
        Import
      </Button>
    </Flex>
  );
}
